module.exports = __webpack_public_path__ + "static/media/city-line-illustration.5cb972f1.png";